// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"267":"component---src-pages-math-strapi-addsub-document-id-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"267":"17e6b2302967dc92c940","293":"693606c984a018768258"}[chunkId] + ".js";
};